import React from "react";
import moment from 'moment';
import {DATE_FORMAT} from "../../../constants/dateFormat";

const LicenceElements = ({record}) => {
    return <div style={{margin: 0}}>{
        JSON.parse(record.content).softwareProductElements.map(({softwareProductElement, productVersion, quantity, expiryDate}) => (
            <p>
                {softwareProductElement} | {productVersion} | Quantity={quantity} | Expires on {moment(new Date(expiryDate)).format(DATE_FORMAT)}
            </p>))
    }
    </div>
};

export default LicenceElements;